import React from 'react';
import './styles/sketch.css';
import './styles/react-tags.css';
import './static/fonts/fonts.css';
import { ThemeProvider } from "@material-ui/core/styles";
import Graph from './components/Graph';
import theme from "./config/Theme.js";

const App = (props) =>{
    return(
        <ThemeProvider theme={theme()}>
            <Graph/>
        </ThemeProvider>
    )
}
export default App;
